<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title
            >Currently Nothing on the Dashboard, Please use the Navigation
            Drawer</v-card-title
          >
        </v-card>
      </v-col>
      <v-col cols="12" md="6" lg="3"> </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapGetters } from "vuex";
  import AppBar from "@/components/AppBar";

  export default {
    components: { AppBar },
    computed: {
      ...mapGetters(["currentUser", "currentUserData"]),
    },
    props: {
      source: String,
    },
    data: () => ({
      drawer: null,
    }),
    mounted() {},
    methods: {},
  };
</script>
